import { Col, Modal, Row } from "antd";
import { useTranslation } from "react-i18next";
import Title from "../../UI/Title/Title";
import { AllUsersListModal } from "./AllUsersListModal";
import { useMutation } from "react-query";
import { changeUsersRole } from "../../../api/roles";
import { useState, useEffect } from "react";
import ResetButton from "../../UI/ResetButton/resetbutton";
import { Search } from "../../UI/Search/Search";
type PropsType = {
  isOpen: boolean;
  setIsOpen: React.Dispatch<React.SetStateAction<boolean>>;
  users: any;
  isLoading: boolean;
  role: any;
};

const AllUsersModal = ({
  isOpen,
  setIsOpen,
  users,
  isLoading,
  role,
}: PropsType) => {
  const { t } = useTranslation("common");
  const [checkedIds, setCheckedIds] = useState<number[]>([]);
  const [usersNotInRole, setUsersNotInRole] = useState([]);

  useEffect(() => {
    users &&
      setUsersNotInRole(users.filter((user: any) => !user.belongsToRole));
  }, [users]);
  const { mutateAsync: addUserToRoleMutation } = useMutation(
    "addUserToRole",
    (userIds: any) => changeUsersRole({ roleId: role, userIds: userIds })
  );

  const handleCheckbox = (checkedId: number) => {
    if (checkedIds.includes(checkedId)) {
      setCheckedIds(checkedIds.filter((id) => id !== checkedId));
    } else {
      setCheckedIds([...checkedIds, checkedId]);
    }
  };
  const resetFilters = () => {
    setTableKey((tableKey) => tableKey + 1);
    setSearchText("");
  };
  const [, setSearchText] = useState("");
  const [tableKey, setTableKey] = useState(1000);
  return (
    <Modal
      centered
      okText="Confirm"
      maskClosable={false}
      closable={false}
      width={800}
      open={isOpen}
      cancelButtonProps={{
        style: {
          color: "#1677FF",
          border: "1px solid #1677FF",
          width: "100px",
          height: "40px",
        },
      }}
      onOk={() => {
        addUserToRoleMutation(checkedIds).then(() => {
          setIsOpen(false);
          setUsersNotInRole([]);
          setCheckedIds([]);
        });
      }}
      onCancel={() => {
        setIsOpen(false);
        setCheckedIds([]);
        setUsersNotInRole([]);
      }}
    >
      <Row gutter={[10, 10]}>
        <Col span={24}>
          <Title title={`${t("permissions")}`} />
        </Col>

        <Col span={24}>
          {" "}
          <span className="modaltitleEdit">
            {t("add-user-to-role")} {""}
          </span>
        </Col>

        <Col span={8}>
          <Search value={""} onKeyPress={""} onChange={""} />
        </Col>

        <Col
          offset={14}
          span={2}
          style={{ display: "flex", justifyContent: "flex-end" }}
        >
          <ResetButton
            onClick={() => {
              resetFilters();
            }}
          />
        </Col>
        <Col span={24}>
          <AllUsersListModal
            tableKey={tableKey}
            loading={isLoading}
            handleCheckbox={handleCheckbox}
            usersNotInRole={usersNotInRole}
            checkedIds={checkedIds}
          />
        </Col>
      </Row>
    </Modal>
  );
};

export default AllUsersModal;
